import user from '@/store/user';
import project from '@/store/project';
import system from '@/store/system';
import task from '@/store/task';
import reports from '@/store/reports';
import dayoff from '@/store/dayoff';
import notificationSettings from '@/store/notificationSettings';
import uiTheme from '@/store/uiTheme';
import { createStore as _createStore } from 'vuex'


export default _createStore({
  modules: {
    user,
    project,
    system,
    task,
    reports,
    dayoff,
    notificationSettings,
    uiTheme,
  },
  state: {
    loading: true,
    loaders: {},
  },
  mutations: {
    startLoading(state, loader) {
      state.loaders[loader] = true;
      state.loading = true;
    },
    stopLoading(state, loader) {
      state.loaders[loader] = false;
      const loading = Object.values(state.loaders).some((v) => {
        if (v) {
          return v;
        }
        return undefined;
      });
      state.loading = loading;
    },
  },
});
